import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const handleAnnualSubscriptionRenewalResponse = (
  accountId: number,
  renewalResponse: 'renew' | 'change' | 'cancel',
  isChargeCreditCard: boolean,
) =>
  createGenericDispatcher({
    name: 'HANDLE_ANNUAL_SUBSCRIPTION_RENEWAL_RESPONSE',
    loadFunction: () =>
      Api.post(`/account/${accountId}/annual-subscription-renewal-response`, {
        body: JSON.stringify({
          renewalResponse,
          isChargeCreditCard,
        }),
      }),
    args: {
      accountId,
      renewalResponse,
      isChargeCreditCard,
    },
  });
